module.exports = __webpack_public_path__ + "static/media/ic-uncheck.94cacd99.svg";